import { z } from 'zod';

export const companyInformationGenerationStatusSchema = z.enum(['NOT_STARTED', 'PENDING', 'SUCCESS', 'FAILED']);

export type CompanyInformationGenerationStatus = z.infer<typeof companyInformationGenerationStatusSchema>;

export const companyInformationErrorCodeSchema = z.enum([
    'LLM_TIMEOUT',
    'LLM_UNAVAILABLE',
    'LLM_INVALID_OUTPUT',
    'SEARCH_UNAVAILABLE',
    'INTERNAL_ERROR',
]);

export type CompanyInformationErrorCode = z.infer<typeof companyInformationErrorCodeSchema>;

export const companyInformationGenerationResultSchema = z.object({
    companyDescription: z.string(),
    companyPriorities: z.string(),
    companySize: z.number().int().positive(),
});

export type CompanyInformationGenerationResult = z.infer<typeof companyInformationGenerationResultSchema>;

export const companyInformationGenerationResponseSchema = z.object({
    companyDomain: z.string().nullable(),
    companyName: z.string().nullable(),
    errorCode: companyInformationErrorCodeSchema.nullable().optional(),
    language: z.string().nullable(),
    result: companyInformationGenerationResultSchema.nullable().optional(),
    status: companyInformationGenerationStatusSchema,
    updatedAt: z.string().nullable(),
});

export type CompanyInformationGenerationResponse = z.infer<typeof companyInformationGenerationResponseSchema>;
